export const entityStatusConfig = {
  Active: {
    label: 'Active',
    className: 'bg-[#edf5ee] text-[#4d7b56] ring-[#dfece0]',
  },
  'Under Review': {
    label: 'Under Review',
    className: 'bg-[#fbf4e8] text-[#b9832e] ring-[#f2e5cd]',
  },
  Terminated: {
    label: 'Terminated',
    className: 'bg-[#f8ece9] text-[#bb5745] ring-[#efd9d4]',
  },
};

export const entityStatuses = Object.keys(entityStatusConfig);

export function getEntityStatusMeta(status) {
  return (
    entityStatusConfig[status] || {
      label: status || 'Unknown',
      className: 'bg-[var(--theme-accent-soft)] text-[var(--theme-accent)] ring-[#e7ddd4]',
    }
  );
}
